/**
 * index-static.ts 5.1.1 - much smaller, everything you need for a static Grid (non draggable, API driven)
 * Copyright (c) 2021 Alain Dumesny - see GridStack root license
 */

export * from './types';
export * from './utils';
export * from './gridstack-engine';
export * from './gridstack-ddi';
export * from './gridstack';

// declare module 'gridstack'; for umd ?
